import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { checkIsDisabledDay, checkIsDisabledRange, toDate as toDateType, validateDate } from "../utils/date";
import { toArray } from "../utils/type";
export var parseValue = function parseValue(value, _ref) {
  var withRange = _ref.withRange;

  if (withRange) {
    var currentValue = toArray(value);
    if (currentValue.length === 0) return '';

    var _currentValue = _slicedToArray(currentValue, 2),
        fromDate = _currentValue[0],
        toDate = _currentValue[1];

    return !toDate ? fromDate : [fromDate, '-', toDate].join(' ');
  }

  return value || '';
};
export var getDefaultValueByType = function getDefaultValueByType(_ref2) {
  var withRange = _ref2.withRange,
      multiple = _ref2.multiple;

  if (withRange || multiple) {
    return [];
  }

  return '';
};
export var validate = function validate(date, _ref3) {
  var withRange = _ref3.withRange,
      timestampMap = _ref3.timestampMap;

  if (withRange) {
    var _date$split = date.split(' '),
        _date$split2 = _slicedToArray(_date$split, 3),
        fromDate = _date$split2[0],
        toDate = _date$split2[2];

    return validateDate(fromDate) && validateDate(toDate) && !checkIsDisabledRange(timestampMap, {
      from: toDateType(fromDate),
      to: toDateType(toDate)
    }) && toDateType(fromDate) <= toDateType(toDate);
  }

  return validateDate(date) && !checkIsDisabledDay(timestampMap, toDateType(date));
};